<div class="flex gap-2">
  <p-button
    type="button"
    label="Reload"
    severity="secondary"
    icon="pi pi-refresh"
    [loading]="isLoading"
    (click)="fetchTableData.emit()"
  />
  <p-button
    type="button"
    severity="secondary"
    label="Clear All Filters"
    icon="pi pi-filter-slash"
    (click)="clearFilters.emit()"
  />
</div>
